import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class ExclamationFilledIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 16 17" {...props}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15.4404C11.866 15.4404 15 12.3064 15 8.44043C15 4.57444 11.866 1.44043 8 1.44043C4.13401 1.44043 1 4.57444 1 8.44043C1 12.3064 4.13401 15.4404 8 15.4404ZM8.91625 11.5004C8.91625 11.3904 8.84625 11.3004 8.73625 11.3004H8.315C8.205 11.3004 8.135 11.2104 8.135 11.0504C8.135 10.8208 8.36907 9.8228 8.56842 8.9729C8.71626 8.3426 8.845 7.79372 8.845 7.70004C8.845 7.54004 8.745 7.44004 8.585 7.44004C8.525 7.44004 8.22112 7.44141 7.91656 7.48394C7.70322 7.50895 7.62398 7.51616 7.5693 7.52113C7.49285 7.52808 7.46441 7.53066 7.18456 7.57148C6.95456 7.60148 6.67219 7.69433 6.67219 7.91433C6.67219 8.10235 6.78078 8.15789 6.89326 8.21541C7.01407 8.2772 7.13937 8.34128 7.13937 8.57433C7.13937 8.78813 7.01746 9.28191 6.88695 9.81047C6.73667 10.4191 6.575 11.0739 6.575 11.4004C6.575 12.0404 6.955 12.2904 7.435 12.2904C8.245 12.2904 8.91625 11.8204 8.91625 11.5004ZM8.365 6.50043C8.705 6.50043 9.425 5.88043 9.425 5.56043C9.425 5.24043 8.885 4.59043 8.585 4.59043C8.255 4.59043 7.525 5.21043 7.525 5.53043C7.525 5.85043 8.065 6.50043 8.365 6.50043Z"
                    fill="currentColor"
                />
            </AbstractIcon>
        );
    }
}
